module.exports = __webpack_public_path__ + "img/数字.b677ef8a.png";